import React from "react";
import {DisplayDictionary} from "../RecruiterParametersDictionaries";

export {RecruiterParametersDictionaryLanguages}

const RecruiterParametersDictionaryLanguages = (props: any) => {
  
  return(<div className={"container white-container"}>
    <h1 className={"profile-edit__title"}>Langues parlées par les candidats</h1>
  
    <DisplayDictionary keyValue={"language"} data={props.dictionary || []} updateDictionaryEntry={()=>{}} deleteDictionaryEntry={()=>{}} />


  </div>);
}